import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../website/component/Header.jsx";
import Footer from "../website/component/Footer.jsx";
import { loadCSS, removeCSS, loadScript, removeScript } from "../utils/domAssets.js";

export default function WebsiteLayout() {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;

    async function loadStyles() {
      await Promise.all([
        loadCSS(
          "https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&family=Inter:wght@400;500;600;700&display=swap",
          "website-fonts",
        ),
        loadCSS("/assets/website/css/style.css", "website-css"),
      ]);

      if (isMounted) {
        setIsLoading(false);
      }
    }

    loadStyles();

    return () => {
      isMounted = false;
      removeCSS("website-fonts");
      removeCSS("website-css");
    };
  }, []);

  // main.js reads the page's DOM (hero stats, search form, etc.), so it must
  // only run after Header/Outlet/Footer have actually mounted below.
  useEffect(() => {
    if (isLoading) return;

    loadScript("/assets/website/js/main.js", "website-main-js");

    return () => {
      removeScript("website-main-js");
    };
  }, [isLoading]);

  if (isLoading) {
    return (
      <div className="website-loader">
        <div className="spinner"></div>
      </div>
    );
  }

  return (
    <>
      <Header />
      <Outlet />
      <Footer />
      <button
        id="backToTop"
        className="back-to-top show"
        aria-label="Back to top"
      >
        ↑
      </button>
    </>
  );
}
